::ng-deep mat-checkbox .mat-checkbox-layout{align-items:start}::ng-deep mat-checkbox .mat-checkbox-inner-container{top:3px}
/*# sourceMappingURL=copy-filing-dialog.component-KYKKRL37.css.map */
